var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"image mw-100",attrs:{"src":_vm.imagePath,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }